import {createFeature, StoreModule} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import {taskSearchItemsReducer} from './reducer/task-search-items.reducer';

export const taskSearchItemStoreConfig = StoreModule.forFeature(
  createFeature({
    name: StoreKeys.TASK_SEARCH_ITEMS,
    reducer: taskSearchItemsReducer
  })
);
